export function walletAndSupportedChainsNames(supportedChains) {
    if (!supportedChains) {
        return null;
    }
    let walletAndSupportedChainsNames = [];
    walletAndSupportedChainsNames = supportedChains.map((blockchainMeta) => blockchainMeta.name);
    return walletAndSupportedChainsNames;
}
export function checkIsWalletPartiallyConnected(wallet, namespacesState) {
    if (!wallet.isHub || !wallet.needsNamespace || wallet.state !== 'connected') {
        return false;
    }
    const namespaces = wallet.needsNamespace.data;
    const supportedNamespaces = namespaces.filter((namespace) => !namespace.unsupported);
    return supportedNamespaces.some((namespace) => !namespacesState?.get(namespace.value)?.connected);
}
export function getAddedAccountsToProfile(profileSummary) {
    return profileSummary.wallets.map((account) => ({
        address: account.address,
        blockchain: account.blockchain,
        walletType: null,
    }));
}
// eslint-disable-next-line @typescript-eslint/no-magic-numbers
export const getConciseAddress = (address, maxChars = 6) => {
    if (address === undefined || address === null) {
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (address.length < 2 * maxChars + 3) {
        return address;
    }
    return address.substr(0, maxChars) + '...' + address.substr(address.length - maxChars);
};
